import { listenForTransitionEnd } from './listenForTransitionEnd';
import { EVENT_TYPE_TO_ANIMATION_STOP_REASON } from './constants';
import { cleanUpEventListeners } from './cleanUpEventListeners';

import { TransitionStopReason } from './types';

export const waitForTransitionToComplete = (element: HTMLElement) =>
  new Promise<TransitionStopReason>((resolve) => {
    const handleCompletion: EventListener = (event) => {
      cleanUpEventListeners(element, handleCompletion);
      resolve(EVENT_TYPE_TO_ANIMATION_STOP_REASON[event.type]);
    };
    listenForTransitionEnd(element, handleCompletion);
  });
